module.exports = __webpack_public_path__ + "static/home_video-5eef9e26bc6bcfbebf4d3bba6b5fd84c.mp4";